import React, { useEffect, useState } from "react";
import "./Footer.css";
import {
  FaChevronUp,
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const Footer = () => {
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  useEffect(() => {
    const footer = document.querySelector("footer");

    if (!footer) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setShowScrollBtn(entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(footer);

    return () => observer.disconnect();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo-section">
          <img src="/logo.png" alt="ETM Academy Logo" className="footer-logo" />
          <div className="footer-socials">
            <a href="https://www.facebook.com/profile.php?id=61555808285747">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/edutechmasteracademy/?hl=en">
              <FaInstagram />
            </a>
            <a href="https://youtube.com/@EduTechMasterAcademy">
              <FaYoutube />
            </a>
            <a
              href="https://www.linkedin.com/in/edutechmaster-academy/"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="#">About</a>
              </li>
              <li>
                <a href="#">Help Centre</a>
              </li>
              <li>
                <a href="#">Business</a>
              </li>
              <li>
                <a href="#">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>About Us</h4>
            <ul>
              <li>
                <a href="#">Terms of Use</a>
              </li>
              <li>
                <a href="#">Our Team</a>
              </li>
              <li>
                <a href="#">How It Works</a>
              </li>
              <li>
                <a href="#">Accessibility</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li>
                <a href="#">FAQs</a>
              </li>
              <li>
                <a href="#">Terms & Conditions</a>
              </li>
              <li>
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <a href="#">Career</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 Created with EduTech Master Academy</p>
      </div>

      {showScrollBtn && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          <FaChevronUp />
        </button>
      )}
    </footer>
  );
};

export default Footer;
